import { IYoutubeScrapeResponseItem } from "@shared/lib/types/influencer";
import { formatData } from "@shared/lib/utils/formatData";
import { MetricCard } from "@shared/ui";
import { Eye, Film, Percent, Users } from "lucide-react";
import { getYoutubeSearchStats } from "../lib/getYoutubeSearchStats";
import styles from "./YoutubeSearchStats.module.scss";

type YoutubeSearchStatsProps = {
  items: IYoutubeScrapeResponseItem[];
};

export function YoutubeSearchStats({ items }: YoutubeSearchStatsProps) {
  if (items.length === 0) {
    return null;
  }

  const stats = getYoutubeSearchStats(items);

  return (
    <div className={styles.statsGrid}>
      <MetricCard
        compact
        icon={<Users size={16} />}
        label="Total Creators / Videos"
        value={`${stats.creatorCount} / ${stats.videoCount}`}
      />
      <MetricCard
        compact
        icon={<Film size={16} />}
        label="Shorts vs Long-form"
        value={`${stats.shortsCount} / ${stats.longFormCount}`}
      />
      <MetricCard
        compact
        icon={<Eye size={16} />}
        label="Avg Views"
        value={formatData(Math.round(stats.avgViews))}
      />
      <MetricCard
        compact
        icon={<Percent size={16} />}
        label="Avg Engagement Rate"
        value={`${stats.avgEngagementRate.toFixed(2)}%`}
      />
    </div>
  );
}
